import ReactTable from "../../components/react-table/finanzas-maintenance";

function MaintenanceFinanzas() {
  return (
    <div>
      <ReactTable contextmenu="mantiene" />
    </div>
  );
}

export default MaintenanceFinanzas;
